<template>
  <ProgramPage v-bind="$props" />
</template>

<script>
import ProgramPage from '~contemporaryTheme/pages/programs/_id'

export default {
  components: {
    ProgramPage,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
}
</script>
